Ext.define('SA.view.sidebar.data.VendorFacetCheckBoxGroup', {
    alias: 'widget.data-search-vendor-checkbox-group',
    extend: 'SA.view.sidebar.data.DataFacetCheckBoxGroup',

    tpl: [
        '<div class="sa-sidebar-data-checkbox-group-title">{title:htmlEncode}</div>',
        '<div class="sa-sidebar-data-checkbox-group-body">',
            '<tpl for="values">',
                '<button data-vendor="{value:htmlEncode}" class="',
                    'sa-sidebar-data-checkbox',
                    '<tpl if="selected === true"> sa-sidebar-data-checkbox-selected</tpl>',
                    '<tpl if="selected === \'indeterminate\'"> sa-sidebar-data-checkbox-indeterminate</tpl>',
                '">',
                    '<span class="sa-sidebar-data-checkbox-button"></span>',
                    '<span class="sa-sidebar-data-checkbox-label">{text:htmlEncode}</span>',
                    ' ',
                    '<span class="sa-sidebar-data-checkbox-count">({count})</span>',
                '</button>',
                '<tpl for="datasets">',
                    '<button data-dataset="{value:htmlEncode}" class="',
                        'sa-sidebar-data-checkbox sa-sidebar-data-child-checkbox',
                        '<tpl if="selected"> sa-sidebar-data-checkbox-selected</tpl>',
                        '<tpl if="count === 0"> sa-sidebar-data-checkbox-empty</tpl>',
                    '">',
                        '<span class="sa-sidebar-data-checkbox-button"></span>',
                        '<span class="sa-sidebar-data-checkbox-label">{datasetSeriesName:htmlEncode}</span>',
                        ' ',
                        '<span class="sa-sidebar-data-checkbox-count">({count})</span>',
                    '</button>',
                '</tpl>',
            '</tpl>',
        '</div>'
    ],

    initComponent() {
        this.vendorCounts = {};

        this.callParent();
    },

    onItemClick(ev, el) {
        var country = SA.AppController.getCurrentCountryCode(),
            dataset = el.getAttribute('data-dataset'),
            vendor, datasets, allSelected;

        if (dataset) {
            this.toggleSelection(dataset);

            return;
        }

        vendor = el.getAttribute('data-vendor');

        if (!vendor) {
            return;
        }

        datasets = SA.model.Country.get(country).getDatasetIdsForVendor(vendor);

        allSelected = datasets.every(dataset => this.selected.includes(dataset));

        if (allSelected) {
            this.removeFromSelection(datasets);
        }
        else {
            this.addToSelection(datasets);
        }
    },

    prepareValues({vendor, counts, selectedDatasets}) {
        var nameSorter = SA.data.Vendors.getDatasetSeriesNameSorter(),
            values = this.callParent([counts, selectedDatasets]).map(setDatasetSeriesName).sort(nameSorter);

        if (vendor === 'Claritas') {
            let prizmPremier = values.find(value => value.value === 'PRZMPUS'),
                prizmLegacy = values.find(value => value.value === 'PRZMUS'),
                nonPrizmDatasets = values.filter(value => !['PRZMPUS', 'PRZMUS'].includes(value.value));

            return [prizmPremier, prizmLegacy, ...nonPrizmDatasets].filter(item => !!item);
        }

        return values;

        function setDatasetSeriesName(value) {
            value.datasetSeriesName = SA.data.Vendors.getDatasetModel(value.value).getName();

            return value;
        }
    },

    refresh() {
        var title = this.title,
            datasetCounts = this.values,
            selected = this.selected,
            vendorCounts = this.vendorCounts,
            country = SA.model.Country.get(SA.AppController.getCurrentCountryCode()),
            vendors = country.getVendors(),
            values = [];

        vendors.forEach(vendor => {
            vendorCounts[vendor] = vendorCounts[vendor] || 0;

            var datasets = country.getDatasetIdsForVendor(vendor),
                selectedDatasets = [],
                counts = {},
                selectedState = false,
                value;

            datasets.forEach(dataset => {
                counts[dataset] = datasetCounts[dataset] || 0;

                if (selected.includes(dataset)) {
                    selectedDatasets.push(dataset);
                }
            });

            if (selectedDatasets.length === datasets.length) {
                selectedState = true;
            }
            else if (selectedDatasets.length) {
                selectedState = 'indeterminate';
            }

            value = {
                count: vendorCounts[vendor],
                datasets: this.prepareValues({vendor, counts, selectedDatasets}),
                selected: selectedState,
                text: vendor,
                value: vendor
            };


            if (value.count || value.selected) {
                values.push(value);
            }
        });

        this.setVisible(values.length);

        this.update({title, values});
    },

    setVendorValues(vendors) {
        this.vendorCounts = vendors;

        this.refresh();
    }
});
